// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTimer = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M9 3h6V1H9zm2 11V8h2v6z" />,
    <path
      fillRule="evenodd"
      d="M21 13a9 9 0 11-9-9c2.125 0 4.078.736 5.618 1.968l1.175-1.175 1.414 1.414-1.175 1.175A8.96 8.96 0 0121 13m-2 0a7 7 0 11-14 0 7 7 0 0114 0"
    />
  );
export default SvgIconTimer;
